import { CSSProperties } from "react";
import styles from "./testimonialCard.module.scss";
import { WistiaPlayer } from "@wistia/wistia-player-react";

export const TestimonialCard = (props: TestimonialCardProps) => {
  const {
    description,
    image,
    studentName,
    studentTitle,
    title,
    style,
    video,
    wistiaId,
  } = props;

  const renderVideo = () => {
    if (wistiaId) {
      return (
        <WistiaPlayer
          id={`wistia-video-${wistiaId}`}
          mediaId={wistiaId}
          aspect={16 / 9}
          controlsVisibleOnLoad
          volumeControl
          className={styles.video}
          key={wistiaId}
        />
      );
    }

    if (video) {
      return (
        <video controls className={styles.video} key={video}>
          <source src={video} type="video/mp4" />
        </video>
      );
    }
  };

  const renderSource = () => {
    if (video || wistiaId) {
      return <div className={styles.videoContainer}>{renderVideo()}</div>;
    }

    if (image) {
      return (
        <div className={styles.imageContainer}>
          <img
            src={image}
            alt={studentName}
            className={styles.image}
            loading="lazy"
          />
        </div>
      );
    }

    return null;
  };

  return (
    <div className={styles.container} style={{ ...style }}>
      {renderSource()}
      {title && <div className={styles.title}>{title}</div>}
      {description && <div className={styles.description}>{description}</div>}
      {(studentName || studentTitle) && (
        <div className={styles.studentInfo}>
          {studentName && (
            <div className={styles.studentName}>{studentName}</div>
          )}
          {studentTitle && (
            <div className={styles.studentTitle}>{studentTitle}</div>
          )}
        </div>
      )}
    </div>
  );
};

export interface TestimonialCardProps {
  image?: string;
  video?: string;
  wistiaId?: string;
  title: string;
  description: string;
  studentName: string;
  studentTitle: string;
  style?: CSSProperties;
}
